import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
// import * as xlsx from "xlsx/xlsx.mjs";
import "./SupplierImport.scss";

import {
  Button,
  Table,
  Form,
  Badge,
  Modal,
  Breadcrumb,
  OverlayTrigger,
} from "react-bootstrap";
import {
  BsQuestionCircle,
  BsCheck,
  BsExclamationTriangleFill,
  BsExclamationCircleFill,
  BsDownload,
  BsFillCheckCircleFill,
} from "react-icons/bs";
import { LOADER_COLOR } from "../../../core/constants/common";
import { BiSearch, BiShareAlt, BiTrash, BiChevronRight } from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";
import ImportDataEdit from "./ImportDataEdit";
import ImportStart from "./ImportStart";
import ImportCompleted from "./ImportCompleted";
import ImportService from "../../../core/service/ImportService";
import ImportFileSelected from "./ImportFileSelected";
import { ScaleLoader } from "react-spinners";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

function SupplierImport({ t }) {
  const navigate = useNavigate();
  const [isImportHome, setIsImportHome] = useState(true);
  const [showEdit, setShowEdit] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showStart, setShowStart] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [showSelectedFile, setShowSelectedFile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileUploadRes, setFileUploadRes] = useState();
  const [jsonData, setJsonData] = useState([]);
  const [selData, setSelData] = useState([]);
  const [color, setColor] = useState(LOADER_COLOR);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState("");

  const handleContinue = () => {
    setIsImportHome(selectedFile ? false : true);
    //  setIsImportHome(false);
    // setShowSelectedFile(selectedFile ? true : false);
    // setShowSelectedFile(true);
    setShowEdit(false);
    setShowImport(false);
    setShowStart(false);
  };
  const callbackEdit = (obj) => {
    if (obj.type === "Continue") {
      setIsImportHome(false);
      // setShowSelectedFile(false);
      setShowEdit(false);
      setShowImport(true);
      setShowStart(false);
      setSelData(obj.data);
    } else if (obj.type === "Back") {
      setIsImportHome(true);
      // setShowSelectedFile(true);
      setShowEdit(false);
      setShowImport(false);
      setShowStart(false);
    }
  };
  const callbackStart = (obj) => {
    if (obj.type === "Continue") {
      setIsImportHome(false);
      // setShowSelectedFile(false);
      setShowEdit(false);
      setShowImport(false);
      setShowStart(true);
    } else if (obj.type === "Back") {
      setIsImportHome(true);
      // setShowSelectedFile(true);
      setShowEdit(false);
      setShowImport(false);
      setShowStart(false);
    }
  };
  const callbackCompleted = (obj) => {
    setIsImportHome(true);
    setShowSelectedFile(false);
    setShowEdit(false);
    setShowImport(false);
    setShowStart(false);
  };
  const callbackSelected = (obj) => {
    if (obj.type === "Continue") {
      setIsImportHome(false);
      setShowSelectedFile(false);
      setShowEdit(true);
      setShowImport(false);
      setShowStart(false);
    } else if (obj.type === "Back") {
      setIsImportHome(true);
      setShowSelectedFile(false);
      setShowEdit(false);
      setShowImport(false);
      setShowStart(false);
    }
  };
  const handleFileSelect = (e) => {
    e.preventDefault();
    const fileUploaded = e.target.files[0];
    // const reader = new FileReader();
    // reader.onload = (e) => {
    //   const data = e.target.result;
    //   const workbook = xlsx.read(data, { type: "array" });
    //   const sheetName = workbook.SheetNames[0];
    //   const worksheet = workbook.Sheets[sheetName];
    //   const jsonData = xlsx.utils.sheet_to_json(worksheet);
    //   setJsonData(jsonData);
    //  // console.log("json", jsonData);
    // };
    // reader.readAsArrayBuffer(fileUploaded);
    setSelectedFile(fileUploaded);
    let msg =
      t("Youhaveselected.label") +
      fileUploaded.name +
      t("Tobeimported.label") +
      " " +
      t("Doyouwanttocontinue.label");
    setConfirmMsg(msg);
    setShowMessageModal(true);
  };

  const fileUpload = (fileSelected) => {
    const formData = new FormData();
    formData.append("multipartFile", fileSelected);
    setLoading(true);
    ImportService.uplaodFile(formData)
      .then((response) => {
        // setShowSelectedFile(true);
        setFileUploadRes(response.data);

        setIsImportHome(false);
        setShowSelectedFile(false);
        setShowEdit(true);
        setShowImport(false);
        setShowStart(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const callbackMessageModal = (boolVal) => {
    setShowMessageModal(false);
    if (boolVal) {
      fileUpload(selectedFile);
    }
  };
  return (
    <div className="SupplierImport">
      <div className="List_header">
        <Breadcrumb className="h5">
          <Breadcrumb.Item onClick={() => {
            navigate(`/company_admin/list_supplier`);
          }}> {t("Suppliers.label")}</Breadcrumb.Item>
          <Breadcrumb.Item active> {t("Import.label")}</Breadcrumb.Item>
        </Breadcrumb>


        
        <div className="List_sorts_menu">
          <ul>
            <li>
              <Link to="/company_admin/list_supplier">
                <Button variant="secondary" className="px-3">
                  {t("Exit.label")}
                </Button>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {isImportHome && (
        <>
          <div className="before_importing01 mt-2">
            <div className="before_importing01_head">
              <h6>
                {t("ImportMainHead.label")} <BsQuestionCircle />
              </h6>
            </div>
            <div className="before_importing01_body row m-0 ">
              {/* d-none */}
              <div className="col-md-4 p-2">
                <div className="before_importing02">
                  <BsCheck />
                  <h6> {t("ImportHead1.label")}</h6>
                  <p>{t("ImportDesc1.label")}</p>
                </div>
              </div>
              <div className="col-md-4 p-2">
                <div className="before_importing02">
                  <BsCheck />
                  <h6>{t("ImportHead2.label")}</h6>
                  <p>{t("ImportDesc2.label")}</p>
                  <a href="#"> {t("ViewdatafieldsinSCMCockpit.label")}</a>
                </div>
              </div>
              <div className="col-md-4 p-2">
                <div className="before_importing02">
                  <BsCheck />
                  <h6> {t("ImportHead3.label")}</h6>
                  <p>{t("ImportDesc3.label")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="data_importing01">
            <div className="data_importing01_head">
              <h6>
                {t("Chooseyourdatatobeimported.label")} <BsQuestionCircle />
              </h6>
            </div>
            <div className="data_importing01_body">
              <div className="card px-4 py-3 Browser_Cardbox mb-2">
                <input
                  type="file"
                  id="Browser_input"
                  onChange={(e) => handleFileSelect(e)}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                />
                <label htmlFor="Browser_input">
                  <h6>{t("BrowseFiles.label")}</h6>
                  <p>{t("FileformatText.label")}</p>
                </label>
              </div>
              <div className="card px-4 py-3 Browser_Cardbox mb-2">
                <h6>{t("IntegratewithSAPsystem.label")}</h6>
              </div>
              <div
                className="card px-4 py-3 Browser_Cardbox mb-2"
                onClick={(e) => {
                  let obj = {
                    type: "Continue",
                  };
                  callbackSelected(obj);
                }}
              >
                <h6>{t("Previuosimport.label")}</h6>
              </div>
              {/* <div className="py-2">
                <Button
                  variant="primary"
                  className="btn px-4"
                  onClick={handleContinue}
                >
                  Continue
                </Button>
              </div> */}
            </div>
          </div>
        </>
      )}
      {loading && (
        <div className="loader-custom">
          <ScaleLoader color={color} loading={true} size={25} />
        </div>
      )}
      {/* {showSelectedFile && (
        <ImportFileSelected
          file={selectedFile}
          callbackSelected={callbackSelected}
        />
      )} */}
      {showEdit && (
        <ImportDataEdit response={fileUploadRes} callbackEdit={callbackStart} />
      )}
      {/* {showImport && (
        <ImportStart param={selData} callbackStart={callbackStart} />
      )} */}
      {showStart && <ImportCompleted callbackCompleted={callbackCompleted} />}
      {showMessageModal && (
        <ConfirmationModal
          modalShow={true}
          messageText={confirmMsg}
          callbackModal={callbackMessageModal}
          confirmBtn={t("Yes.label")}
          CancelBtn={t("No.label")}
        />
      )}
    </div>
  );
}
export default withTranslation()(SupplierImport);
